import { render, staticRenderFns } from "./return-modal.vue?vue&type=template&id=5805003e&scoped=true&"
import script from "./return-modal.vue?vue&type=script&lang=js&"
export * from "./return-modal.vue?vue&type=script&lang=js&"
import style0 from "./return-modal.vue?vue&type=style&index=0&id=5805003e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805003e",
  null
  
)

export default component.exports